module.exports = __webpack_public_path__ + "static/media/2.1fe300b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/2.png
// module id = 657
// module chunks = 0